import { fetcher } from "../helpers/global";
import { getCartToken } from "../services/cart.service";

export function updateFrequency(frequency) {
  const cartToken = getCartToken();
  const url = "jsonapi/frequency";
  const data = { frequency };
  const headers = {
    "content-type": "application/vnd.api+json",
    "Commerce-Cart-Token": cartToken,
  };

  return fetcher("PATCH", url, null, headers, data).then((res) => {
    return res.data[0].attributes.frequency;
  });
}
